export default __webpack_public_path__ + "static/media/hangup_icon.35b23011.svg";